//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  components: {
    Confirm,
  },
  data() {
    return {
      resource: this.$api.cacheManager(this.$resource),
    };
  },
  methods: {
    checkAndDrop() {
      this.$refs.dialog.open();
    },
    dropCache() {
      this.resource.dropCache();
    },
  },
};



// WEBPACK FOOTER //
// ./src/spa/administracao/CacheManager.vue?vue&type=script&lang=js&